import { render, staticRenderFns } from "./MyCollectionGroup.vue?vue&type=template&id=12ce071f&"
import script from "./MyCollectionGroup.vue?vue&type=script&lang=js&"
export * from "./MyCollectionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports